export { default as CategoryMenuImg } from './category_menu.png';
